type RuntimeEnv = {
  VITE_TAF_ENV?: string
  DEV?: boolean
}

export interface TafRuntimeConfig {
  isDebug: boolean
  showLog: boolean
}

export function resolveTafRuntimeConfig(env: RuntimeEnv, search: string): TafRuntimeConfig {
  if (env.VITE_TAF_ENV !== 'test' && env.VITE_TAF_ENV !== 'production') {
    throw new Error('VITE_TAF_ENV must be "test" or "production"')
  }

  return {
    isDebug: env.VITE_TAF_ENV === 'test',
    showLog: Boolean(env.DEV) || new URLSearchParams(search).has('debug'),
  }
}
